const apikeymap={
    apikey:process.env.REACT_APP_GOOGLE_MAPS_API_KEY
}

export default apikeymap